import React, { createContext, useContext } from 'react';

/* ========================================================================= */
/* Context(s) */
/* ========================================================================= */

/** @type {import('$types/components/contexts').OfficeContext} */
const OfficeContext = createContext(null);

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

const useOffice = () => {
    const context = useContext(OfficeContext);

    if (context === undefined) {
        throw new Error('useOffice must be used within a OfficeProvider.');
    }

    return context;
};

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/** @type {import('$types/components/contexts').OfficeContextProvider} */
const OfficeProvider = ({ children, contact, saleProperties, rentalProperties, externalId }) => {
    return (
        <OfficeContext.Provider value={{ contact, saleProperties, rentalProperties, externalId }}>
            {children}
        </OfficeContext.Provider>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

OfficeContext.displayName = 'OfficeContext';

export {
    OfficeProvider,
    useOffice
};
